import { apiSlice } from "../../stores/base/api-slice";

export interface WorkflowStatusesResponse {
	activeOrderWorkflowStatuses: WorkflowStatus[];
	recomendationWorkflowStatus: RecommendationWorkflowStatus | null;
}

export interface WorkflowStatus {
	workflowId: string;
	status: number;
	type: string;
	userFriendlyStatus: string;
}

export interface RecommendationWorkflowStatus {
	workflowId: string;
	status: number;
	paymentType: number;
}

const workflowStatusesEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getWorkflowStatuses: builder.query<WorkflowStatusesResponse, void>({
			query: () => ({
				url: "/dashboard/workflow-statuses",
				method: "GET",
			}),
		}),
	}),
});

export const { useGetWorkflowStatusesQuery } = workflowStatusesEndpoints;
